// extracted by mini-css-extract-plugin
export default {"wrapper":"hqlOe","buttonsOverride":"MWBHN"};